import React from 'react';
import {useStyles} from "./BillingPeriodClosureRow.style";
import clsx from "clsx";
import BillingPeriodClosureRowProperties from "./BillingPeriodClosureRowProperties";
import ShowDate from "../../../shared_components/Info/ShowDate/ShowDate";
import ShowPrice from "../../../shared_components/Info/ShowPrice/ShowPrice";

const BillingPeriodClosureRowSmall: React.FC<BillingPeriodClosureRowProperties> = ({
                                                            closure
                                                        }) => {

    const classes = useStyles();

    return (
        <div className={clsx(classes.closure_row_small)}>
            <div className={classes.small_header}>
                {closure.agencyId}
                <ShowPrice value={closure.totalAmount} className={classes.price_small}/>
            </div>
            <div className={classes.small_details}>
                <ShowDate timestamp={closure.closureDate} label="Fecha"/>
                {closure.notes && (
                    <div className={classes.notes_small}>
                        <span className={classes.notes_label}>Notas:</span> {closure.notes}
                    </div>
                )}
            </div>
        </div>
    )
}

export default BillingPeriodClosureRowSmall;
